import React, { useState, useEffect } from 'react';
import { BorderedTextInput } from '../../HouseStyle/Components/Inputs';
import { ButtonBlue } from '../../HouseStyle/Components/Buttons';
import ToastError from '../../Toasts/ToastError';

const Step1ACompanyInfo = ({ data, updateData, onNext }) => {
  const [formData, setFormData] = useState({
    company_name: data.company_name || '',
    vatnumber: data.vatnumber || '',
    cocnumber: data.cocnumber || '',
    iban: data.iban || ''
  });

  useEffect(() => {
    setFormData({
      company_name: data.company_name || '',
      vatnumber: data.vatnumber || '',
      cocnumber: data.cocnumber || '',
      iban: data.iban || ''
    });
  }, [data]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    updateData({ [field]: value });
  };

  const handleNext = () => {
    // Validate required fields
    if (!formData.company_name || String(formData.company_name).trim() === '') {
      ToastError('Vul de bedrijfsnaam in');
      return;
    }
    // KVK number validation
    if (formData.cocnumber && formData.cocnumber.trim() !== '') {
      const isValidKVK = /^\d{8}$/.test(formData.cocnumber.trim());
      if (!isValidKVK) {
        ToastError('KVK nummer moet uit precies 8 cijfers bestaan');
        return;
      }
    }
    // BTW number validation (Dutch VAT: NL[9 digits][B][2 digits])
    if (formData.vatnumber && formData.vatnumber.trim() !== '') {
      const btwRegex = /^NL\d{9}B\d{2}$/i;
      if (!btwRegex.test(formData.vatnumber.trim())) {
        ToastError('Vul een geldig BTW nummer in (bijv. NL123456789B01)');
        return;
      }
    }
    // IBAN validation (basic, NL IBAN: NL[2 digits][4 letters][10 digits])
    if (formData.iban && formData.iban.trim() !== '') {
      const ibanRegex = /^NL\d{2}[A-Z]{4}\d{10}$/;
      if (!ibanRegex.test(formData.iban.replace(/\s+/g, '').toUpperCase())) {
        ToastError('Vul een geldig IBAN nummer in (bijv. NL91ABNAA0417164300)');
        return;
      }
    }
    onNext();
  };

  return (
    <div className="step-container">
      <div className="step-content-area">
        <div className="step-form">
          <h2 className="step-title">Bedrijfsgegevens</h2>
          <p className="required-note">Invulvelden met een (*) zijn verplicht om in te vullen</p>
          <div className="col-md-12 mt-3">
            <BorderedTextInput
              label="Bedrijfsnaam *"
              placeholder="..."
              required={true}
              setInputValue={(value) => handleInputChange('company_name', value)}
              inputValue={formData.company_name}
            />
          </div>
          <div className="col-md-12 mt-3">
            <BorderedTextInput
              label="BTW nummer"
              placeholder="..."
              required={false}
              setInputValue={(value) => handleInputChange('vatnumber', value)}
              inputValue={formData.vatnumber}
            />
          </div>
          <div className="col-md-12 mt-3">
            <BorderedTextInput
              label="KVK nummer"
              placeholder="..."
              required={false}
              setInputValue={(value) => handleInputChange('cocnumber', value)}
              inputValue={formData.cocnumber}
            />
          </div>
          <div className="col-md-12 mt-3">
            <BorderedTextInput
              label="IBAN nummer"
              placeholder="..."
              required={false}
              setInputValue={(value) => handleInputChange('iban', value)}
              inputValue={formData.iban}
            />
          </div>
        </div>
        {/* Info Sidebar */}
        <div className="info-sidebar">
          <div className="info-section">
            <h3>Geldig BTW nummer</h3>
            <p>Een geldig BTW nummer begint met 'NL', gevolgd door 9 cijfers, de letter 'B' en 2 controlecijfers.</p>
          </div>

          <div className="info-section">
            <h3>Geldig KVK nummer</h3>
            <p>Een geldig KVK nummer bestaat uit 8 cijfers.</p>
          </div>

          <div className="info-section">
            <h3>Geldig IBAN nummer</h3>
            <p>Een geldig Nederlands IBAN nummer begint met 'NL', gevolgd door 2 controlecijfers, 4 letters (bankcode) en 10 cijfers (rekeningnummer).</p>
          </div>
        </div>
      </div>
      <div className="form-actions">
        <ButtonBlue
          onClickFunction={handleNext}
          text="Verder"
        />
      </div>
    </div>
  );
};

export default Step1ACompanyInfo;
